import type { ComponentType } from "svelte";

export class BulkAction {

    private icon: ComponentType;
    private label: string;
    private items: any[] = [];
    public visible: boolean;
    public handler: (_items: any[]) => void;

    constructor(icon: ComponentType, label: string, handler: (_items: any[]) => void, visible: boolean) {
        this.icon = icon;
        this.label = label;
        this.handler = handler;
        this.visible = visible;
    }

    getIcon(): ComponentType {
        return this.icon;
    }

    getLabel(): string {
        return this.label;
    }

    setVisibility(visible: boolean): BulkAction {
        this.visible = visible;
        return this;
    }

    isVisible(): boolean {
        return this.visible;
    }

    setItems(items: any[]): BulkAction {
        this.items = items;
        return this;
    }

    getItems(): any[] {
        return this.items;
    }

}